import { render, staticRenderFns } from "./DescricaoWindowLB.vue?vue&type=template&id=3b3b055d&scoped=true&"
import script from "./DescricaoWindowLB.vue?vue&type=script&lang=js&"
export * from "./DescricaoWindowLB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b055d",
  null
  
)

export default component.exports